<template>
  <AppLayout>
    <VContainer
      fluid
      fill-height
    >
      <VLayout
        align-center
        justify-center
      >
        <VFlex
          xs12
          md8
        >
          <VCard class="elevation-12">
            <VToolbar
              dark
              color="primary"
            >
              <VToolbarTitle>{{ $t('heading') }}</VToolbarTitle>
              <VSpacer />
              <VTooltip bottom>
                <VBtn
                  slot="activator"
                  icon
                  large
                  :to="{name: 'home'}"
                >
                  <VIcon large>
                    home
                  </VIcon>
                </VBtn>
                <span>{{ $t('home') }}</span>
              </VTooltip>
            </VToolbar>
            <VCardText>
              <VAlert
                v-if="updateEmailError"
                :value="true"
                type="error"
              >
                {{ $t('updateError') }}
              </VAlert>
              <VProgressLinear
                v-else
                :indeterminate="true"
              />
            </VCardText>
            <VCardActions v-if="updateEmailError">
              <VSpacer />
              <VBtn
                flat
                color="primary"
                :to="{name: 'login'}"
              >
                {{ $t('home') }}
              </VBtn>
            </VCardActions>
          </VCard>
        </VFlex>
      </VLayout>
    </VContainer>
  </AppLayout>
</template>

<script>
import UserApi from '@/api/UserApi'

export default {
  name: 'EmailUpdateConfirm',
  props: [],
  data () {
    return {
      updateEmailError: false
    }
  },
  methods: {
    redirectToLogin () {
      setTimeout(_ => {
        this.$router.push({ name: 'login' })
      }, 2000)
    }
  },
  async created () {
    try {
      await this.$notification(await UserApi.updateEmailConfirm({ hash: this.$route.query.hash }))
      this.redirectToLogin()
    } catch (e) {
      this.updateEmailError = true
      await this.$notification(e)
    }
  },
  i18n: {
    messages: {
      de: {
        heading: 'Email aktualisieren',
        home: 'Zurück',
        updateError: 'Fehler beim Aktualisieren',
      },
      en: {
        heading: 'Update email',
        home: 'Back',
        updateError: 'Error while updating',
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
